import { render, staticRenderFns } from "./AccountingItemsRelationSettings.vue?vue&type=template&id=429a8472&"
import script from "./AccountingItemsRelationSettings.vue?vue&type=script&lang=js&"
export * from "./AccountingItemsRelationSettings.vue?vue&type=script&lang=js&"
import style0 from "./AccountingItemsRelationSettings.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports